interface Props {
  size?: number;
  color?: string;
}
const DashboardIcon = (props: Props) => {
  const { color = '#000', size = 25 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 ${size} ${size}`}
    >
      <g
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        clipPath="url(#clip0_1409_389)"
      >
        <path d="M11.437 16.6a5.02 5.02 0 0 1-5.01-5.01A4.984 4.984 0 0 1 10.5 6.667v-.885a5.86 5.86 0 0 0-4.95 5.81 5.896 5.896 0 0 0 5.887 5.886 5.86 5.86 0 0 0 5.809-4.95h-.885a5 5 0 0 1-4.924 4.074Z"></path>
        <path d="m12.038 5.738-.481-.051v5.783h5.783l-.051-.48a5.89 5.89 0 0 0-5.251-5.252Zm.387 4.864V6.684a5.02 5.02 0 0 1 3.918 3.918z"></path>
        <path d="m20.872 18.19-.008-.739c0-2.818.008-10.888 0-14.411 0-1.272-.989-2.235-2.277-2.235H4.433c-.62 0-1.238.267-1.702.74a2.38 2.38 0 0 0-.705 1.684c.017 4.993.017 8.19.009 12.237v4.375c0 .678.258 1.314.73 1.787.473.473 1.109.73 1.788.73h7.27c2.243 0 4.538 0 6.806-.008.25 0 .499-.043.714-.112.902-.31 1.52-1.177 1.538-2.148-.009-.636-.009-1.28-.009-1.9Zm-.885 1.883c-.008.601-.386 1.143-.945 1.332-.12.043-.267.068-.43.068-2.26.009-4.554.009-6.806.009h-7.27a1.615 1.615 0 0 1-1.642-1.633v-4.374c0-4.048.009-7.245-.008-12.238 0-.395.154-.773.447-1.065.3-.301.696-.473 1.082-.473H18.57c.825 0 1.401.559 1.401 1.358.009 3.515 0 11.593 0 14.412l.009.739a45 45 0 0 1 .008 1.865Z"></path>
      </g>
      <defs>
        <clipPath id="clip0_1409_389">
          <path fill="#fff" d="M.445.582h22v22h-22z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default DashboardIcon;
